import { Former } from './Former'
import { str } from '@/js/formers/op-build-helpers'
import _isEmpty from 'lodash/isEmpty'

/**
 * @typedef VerificationCDDFormerAttrs
 * @type {object}
 */

/**
 * Collects the attributes for sticker-related operations
 * @class
 * @implements {Former}
 */
const customerRiskFactorsKeys = [
  'qus01',
  'qus02',
  'qus03',
  'qus04',
  'qus05',
  'qus06',
  'qus07',
]

const productServiceRiskFactorsKeys = [
  'qus01',
  'qus02',
  'qus03',
  'qus04',
  'qus05',
  'qus06',
]

const geoRiskKeys = ['qus01']

const riskAssmntKeys = [
  'comments',
  'subscriber',
  'signatureDate',
  'lowRisk',
  'generalRisk',
  'highRisk',
]

const pepKeys = [
  'qus01',
  'qus02',
  'qus03',
  'qus04',
  'qus05',
  'qus06',
  'qus07',
  'qus08',
  'qus09',
]

const checkListKeys = [
  'qus01',
  'qus02',
  'qus03',
  'qus04',
  'pepInfo',
  'countryRisk',
  'description',
  'riskFactors',
]

export class VerificationBDDFormer extends Former {
  /** @type {VerificationCDDFormerAttrs} */
  attrs = _isEmpty(this.attrs) ? this._defaultAttrs : this.attrs

  _opBuilder = this._opBuilder || this._buildOpCreate

  get _defaultAttrs () {
    const customerRiskFactors = {}
    customerRiskFactorsKeys.forEach(key => {
      customerRiskFactors[key] = ''
    })

    const productServiceRiskFactors = {}
    productServiceRiskFactorsKeys.forEach(key => {
      productServiceRiskFactors[key] = ''
    })

    const geoRisk = {}
    geoRiskKeys.forEach(key => {
      geoRisk[key] = ''
    })

    const riskAssmnt = {}
    riskAssmntKeys.forEach(key => {
      riskAssmnt[key] = ''
    })

    const pep = {}
    pepKeys.forEach(key => {
      pep[key] = ''
    })

    const checkList = {}
    checkListKeys.forEach(key => {
      checkList[key] = ''
    })

    return {
      customerRiskFactors,
      productServiceRiskFactors,
      geoRisk,
      riskAssmnt,
      pep,
      checkList,
      rejectReason: {
        reason: '',
      },
    }
  }

  buildOps () {
    return this._opBuilder()
  }

  /** @param {VerificationCDDRecord} source */
  populate (source) {
    const {
      customerRiskFactors,
      productServiceRiskFactors,
      geoRisk,
      riskAssmnt,
      pep,
      checkList,
    } = source
    if (!this.attrs.customerRiskFactors) {
      this.attrs.customerRiskFactors = {}
    }
    Object.keys(customerRiskFactors).forEach(key => {
      this.attrs.customerRiskFactors[key] = customerRiskFactors[key] || ''
    })

    if (!this.attrs.productServiceRiskFactors) {
      this.attrs.productServiceRiskFactors = {}
    }
    Object.keys(productServiceRiskFactors).forEach(key => {
      this.attrs.productServiceRiskFactors[key] = productServiceRiskFactors[key] || ''
    })

    if (!this.attrs.geoRisk) {
      this.attrs.geoRisk = {}
    }
    Object.keys(geoRisk).forEach(key => {
      this.attrs.geoRisk[key] = geoRisk[key] || ''
    })

    if (!this.attrs.riskAssmnt) {
      this.attrs.riskAssmnt = {}
    }
    Object.keys(riskAssmnt).forEach(key => {
      this.attrs.riskAssmnt[key] = riskAssmnt[key] || ''
    })

    if (!this.attrs.pep) {
      this.attrs.pep = {}
    }
    Object.keys(pep).forEach(key => {
      this.attrs.pep[key] = pep[key] || ''
    })

    if (!this.attrs.checkList) {
      this.attrs.checkList = {}
    }
    Object.keys(checkList).forEach(key => {
      this.attrs.checkList[key] = checkList[key] || ''
    })

    this.attrs.rejectReason = {
      reason: '',
    }
  }

  _buildOpCreate () {
    return {
      customerRiskFactors: this._customerRiskFactors(),
      productServiceRiskFactors: this._productServiceRiskFactors(),
      geoRisk: this._geoRisk(),
      riskAssmnt: this._riskAssmnt(),
      pep: this._pepDetails(),
      checkList: this._checkListDetails(),
      rejectReason: this.attrs.rejectReason,
    }
  }

  _customerRiskFactors () {
    const { customerRiskFactors } = this.attrs
    const result = {}
    Object.keys(customerRiskFactors).forEach(key => {
      result[key] = str(customerRiskFactors[key])
    })
    return result
  }
  _productServiceRiskFactors () {
    const { productServiceRiskFactors } = this.attrs
    const result = {}
    Object.keys(productServiceRiskFactors).forEach(key => {
      result[key] = str(productServiceRiskFactors[key])
    })
    return result
  }
  _geoRisk () {
    const { geoRisk } = this.attrs
    const result = {}
    Object.keys(geoRisk).forEach(key => {
      result[key] = str(geoRisk[key])
    })
    return result
  }

  _riskAssmnt () {
    const { riskAssmnt } = this.attrs

    const result = {}
    Object.keys(riskAssmnt).forEach(key => {
      result[key] = riskAssmnt[key]
    })
    return result
  }

  _pepDetails () {
    const { pep } = this.attrs

    const result = {}
    Object.keys(pep).forEach(key => {
      result[key] = str(pep[key])
    })
    return result
  }
  _checkListDetails () {
    const { checkList } = this.attrs

    const result = {}
    Object.keys(checkList).forEach(key => {
      result[key] = str(checkList[key])
    })
    return result
  }
}
